module.exports = __webpack_public_path__ + "img/akevv-agrvj.2427010b.png";